<div class="pb-6 text-4xl leading-none font-extrabold tracking-tight">{{ title() }}</div>
@if (currentUser(); as user) {
  <aura-person-identity-edit
    [(isEditing)]="isEditingIdentityNames"
    showMode="names"
    [initialIdentity]="user.identity"
    (identitySaved)="saveIdentityNames($event)"
  />
  <aura-person-identity-edit
    [(isEditing)]="isEditingIdentityDemographics"
    showMode="demographics"
    [initialIdentity]="user.identity"
    (identitySaved)="saveIdentityDemographics($event)"
  />
  <aura-person-avatar-edit
    [(isEditing)]="isEditingAvatar"
    [firstName]="user.identity.firstName"
    [initialAvatar]="user.identity.avatar"
    (avatarSaved)="saveAvatar($event)"
  />
  <aura-contact-infos-email-edit
    [(isEditing)]="isEditingEmail"
    [isAllowedToEdit]="isAllowedToEditEmail()"
    [initialEmail]="user.contactInfos.email"
    (emailSaved)="saveContactEmail($event)"
  />
  <aura-contact-infos-phone-edit
    [(isEditing)]="isEditingMobileNumber"
    [isAllowedToEdit]="isAllowedToEditMobile()"
    [initialMobileNumber]="user.contactInfos.mobileNumber!"
    (phoneNumberSaved)="saveContactMobileNumber($event)"
  />
}
